import { VFC } from 'react'
import { asModal } from 'src/components/hoc/asModal'
import { Persona } from 'src/models/Persona'
import { truewhite, _profileoverlay } from 'src/styles/colors'
import styled, { css } from 'styled-components'
import { PersonasContent } from './PersonasContent'

export type PersonasContentModalViewProps = {
  personaData: Persona
  close: VoidFunction
}

const PersonasContentModalView: VFC<PersonasContentModalViewProps> = ({
  personaData,
  close,
}) => {
  return (
    <Layout>
      <PersonasContentModalHeader>選択中の項目</PersonasContentModalHeader>
      <PersonasContentDiv>
        <PersonasContent personaData={personaData} />
      </PersonasContentDiv>
      <FilterParamButton>
        <CancelButton type="button" onClick={close}>
          閉じる
        </CancelButton>
      </FilterParamButton>
    </Layout>
  )
}

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: ${_profileoverlay}80;
`

export const PersonasContentModal = asModal(PersonasContentModalView, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const Layout = styled.div`
  width: 530px;
  height: 480px;
  background: ${truewhite};
  border-radius: 10px;
  padding: 20px 40px;
`

const PersonasContentModalHeader = styled.div`
  font-size: 14px;
  color: #393e4c40;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;
`

const FilterParamButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: 40px;
`

const CancelButton = styled.button`
  display: inline-block;
  padding: 6px 16px;
  color: #02b7b0;
  background: white;
  width: 90px;

  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 3px 6px rgb(0 0 0 / 10%);
  border-radius: 5px;
  margin-right: 10px;
  outline: none;

  text-align: center;
  line-height: 1.4;
`

const PersonasContentDiv = styled.div`
  width: 100%;
  border: 1px solid #393e4c40;
  padding: 10px;
  height: 280px;
  border-radius: 10px;
  overflow: scroll;
`
